/* <experience-report-form> — live's inline submit script (O-06 FormSubmit.co
   surface), behavior 1:1: on submit the button is hidden first, the default
   is prevented, then either the serialized FormData is POSTed to the form's
   FormSubmit.co action (fetch; success shows #msg and resets the form,
   failure restores the button) or the fields are POSTed as JSON to the
   custom endpoint via XHR (success shows #msg, failure restores the button).
   The endpoint arrives via data-form-endpoint instead of live's inline
   `| json` interpolation; the form's action, data-use-formsubmit switch,
   field names and ids are the live contract, untouched. */

class ExperienceReportForm extends HTMLElement {
  connectedCallback() {
    var form = this.querySelector('#mystory');
    if (!form) return;
    var formEndpoint = this.dataset.formEndpoint;
    var useFormsubmit = form.getAttribute('data-use-formsubmit') === 'true';

    form.addEventListener('submit', function (event) {
      document.getElementById('subbtn').style.display = 'none';
      event.preventDefault();

      if (useFormsubmit) {
        var formData = new FormData(form);
        fetch(form.action, {
          method: 'POST',
          body: formData,
        })
          .then(function (response) {
            if (response.ok) {
              document.getElementById('msg').style.display = 'block';
              form.reset();
            } else {
              document.getElementById('subbtn').style.display = 'block';
            }
          })
          .catch(function () {
            document.getElementById('subbtn').style.display = 'block';
          });
      } else {
        var plainFormData = new FormData(form);
        var data = {};
        plainFormData.forEach(function (value, key) {
          data[key] = value;
        });
        var xhr = new XMLHttpRequest();
        xhr.open('POST', formEndpoint, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            document.getElementById('msg').style.display = 'block';
          } else if (xhr.readyState === 4) {
            document.getElementById('subbtn').style.display = 'block';
          }
        };
        xhr.send(JSON.stringify(data));
      }
    });
  }
}

if (!customElements.get('experience-report-form')) {
  customElements.define('experience-report-form', ExperienceReportForm);
}
